<div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">
  <div class="container" style="max-width: 400px;">
    
    <app-card title="Login">

      <div class="mb-2 text-center">
        <div  [ngClass]="{'logo': isProd, 'logo-training': !isProd && !isStaging, 'logo-staging': !isProd && isStaging}" ></div>
      </div>
      
      <div class="mb-3">
        <label class="form-label">Email Address</label>
        <input type="email" 
               class="form-control" 
               [(ngModel)]="emailAddress" 
               placeholder="Email Address"
               autocomplete="username email">
      </div>

      <div class="mb-3">
        <label class="form-label">Password</label>
        <input type="password" 
               class="form-control" 
               [(ngModel)]="password" 
               placeholder="Password"
               (keyup.enter)="login()"
               autocomplete="password">
      </div>

      <div class="mb-3">
        <a [routerLink]="'/forgotpassword'" class="adl-link">Forgot Password</a>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <div class="text-danger me-3" *ngIf="errorMessage">
          {{errorMessage}}
        </div>

        <button *ngIf="!loggingIn" 
                type="button" 
                class="btn btn-success" 
                (click)="login()">
          Login
        </button>

        <button *ngIf="loggingIn" 
                type="button" 
                class="btn btn-success" 
                disabled>
          <span class="spinner-border spinner-border-sm me-2"></span>
          Logging in...
        </button>
      </div>
    </app-card>

  </div>
</div>